import { getLocalStorageItem, useOutsideClick } from '../../../utils/helper.js';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';
import Loader from '../../../component/common/Loader.js';
import Topbar2 from '../../PulseSurvey/Topbar.js';
import AddDetails from './AddDetails.js';
import BadgeTaskForm from '../../B2B/B2BAdmin/Badges/Components/BadgeTaskForm.js';
import TaskRewardForm from '../components/Reward.js';
import WinnerResult from '../components/WinnerResult.js';
import ChallengePreview from './ChallengePreview.js';
import Summary from './Summary.js';
import toast from 'react-hot-toast';
import { ApiForRole } from './ApiForRole.js';
import { Api } from '../../../api/index.js';

function NewChallenges() {
  const location = useLocation();
  const state = location.state;
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  // console.log(state?._id, 'state_idddddd');
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [showPage, setShowPage] = useState('');
  const [newChallenge, setNewChallenge] = useState('false');

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  // Update showPage state based on URL query parameter
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get('page');
    const newChallengeParam = queryParams.get('newchallenge');
    setShowPage(pageParam ? pageParam.toLowerCase() : 'details');
    setNewChallenge(newChallengeParam);
  }, [location.search]);

  const handlePageChange = (page) => {
    setShowPage(page.toLowerCase());
    navigate(
      userData?.slug
        ? `/${userData?.slug}/challenges/create-new-challenges?page=${page}&newchallenge=${newChallenge}`
        : `/challenges/create-new-challenges?page=${page}&newchallenge=${newChallenge}`,
      {
        state: {
          _id: state?._id,
          imageUrl: state?.imageUrl
        }
      }
    );
  };
  const [data, setData] = useState({});
  const [allData, setAllData] = useState({});

  // console.log(data, 'dataaaaaaaa');

  // Updated handleFinalSubmit function for NewChallenges component

  const handleFinalSubmit = async () => {
    const body = {
      challenge_id: state?._id
    };

    const convertToTotalMinutes = (hours, mins) => {
      const hoursNum = parseInt(hours) || 0;
      const minsNum = parseInt(mins) || 0;
      return hoursNum * 60 + minsNum;
    };

    const flatTasks =
      data?.tasks?.flatMap((group) =>
        group.sub_tasks.map((task) => {
          const baseTask = {
            id: task.id !== 0 ? task.id : null,
            feature: task?.backend_name,
            isSubscription:
              task?.isSubscription === 1 ? true : task?.isSubscription === 0 ? false : '',
            duration: task?.hours && task?.mins ? convertToTotalMinutes(task.hours, task.mins) : 0,
            backend_name: task?.backend_name,
            description: task?.description,
            days: task?.days,
            number_of_tries: task?.number_of_tries,
            title: task?.title,
            status: task?.status
          };

          // Handle wearable device tasks
          if (task?.feature === 'Wearable Device') {
            baseTask.connect_to_wearable = true; // Always true for wearable tasks

            // Add wearable configuration if it exists
            if (task?.wearableConfig) {
              baseTask.wearableConfig = {
                dataType: task.wearableConfig.dataType,
                targetValue: Number(task.wearableConfig.targetValue),
                unit: task.wearableConfig.unit,
                trackingPeriod: task.wearableConfig.trackingPeriod || 'daily',
                aggregationType: task.wearableConfig.aggregationType || 'sum'
              };
            }
          } else {
            // For non-wearable tasks, use the existing logic
            baseTask.connect_to_wearable =
              task?.connect_to_wearable === 1 ? true : task?.connect_to_wearable === 0 ? false : '';
          }

          return baseTask;
        })
      ) || [];

    if (flatTasks.length > 0) {
      body.tasks = flatTasks;
    }

    console.log(body, 'request body with wearable support');

    try {
      const response = await ApiForRole().addChallengesTask(body);

      if (response?.status === 200) {
        toast.success(response?.data?.message);
        navigate(
          userData?.slug
            ? `/${userData?.slug}/challenges/create-new-challenges?page=reward&newchallenge=${newChallenge}`
            : `/challenges/create-new-challenges?page=reward&newchallenge=${newChallenge}`,
          {
            state: {
              _id: response?.data?.challenge?._id,
              imageUrl: state?.imageUrl
            }
          }
        );
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setLoader(false);
      toast.error('An error occurred while saving tasks');
      console.error('Error saving tasks:', error);
    }
  };

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Marketplace | Shoorah Admin</title>
        </Helmet>
        {loader ? <Loader /> : null}
        <Topbar2
          title={
            showPage === 'details'
              ? 'Challenges/New Challenge'
              : showPage === 'tasks'
              ? 'Challenges/New Challenge'
              : showPage === 'reward'
              ? 'Challenges/New Challenge'
              : showPage === 'summary'
              ? 'Challenges/New Challenge'
              : showPage === 'results'
              ? 'Challenges/New Challenge'
              : showPage === 'preview'
              ? 'Challenges/New Challenge'
              : ''
          }
          infoBtn={false}
        />
      </div>

      <div className="relative lg:mb-[45px]">
        {showPage !== 'preview' && (
          <div className="flex flex-wrap sm:flex-nowrap justify-between items-center w-full gap-4 lg:gap-12">
            <div className="flex gap-4 sm:gap-8">
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'details'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('details')}
              >
                Details
              </div>
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'tasks'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('tasks')}
              >
                Tasks
              </div>
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'reward'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('reward')}
              >
                Reward
              </div>
              {newChallenge === 'false' && (
                <>
                  <div
                    className={`cursor-pointer text-[20px] font-medium leading-9 ${
                      showPage === 'results'
                        ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                        : 'text-shoorah-gray9'
                    }`}
                    onClick={() => handlePageChange('results')}
                  >
                    Results
                  </div>
                  
                  <div
                    className={`cursor-pointer text-[20px] font-medium leading-9 ${
                      showPage === 'summary'
                        ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                        : 'text-shoorah-gray9'
                    }`}
                    onClick={() => handlePageChange('summary')}
                  >
                    Summary
                  </div>
                </>
              )}
            </div>
            {state?._id && (
              <div className="flex justify-center items-center w-full sm:w-[170px] h-[40px] text-[14px] border border-[#0B1D2E] rounded-[100px] ">
                <div className="relative inline-block text-left">
                  <button
                    type="button"
                    le
                    dropdown
                    on
                    button
                    click
                    className="inline-flex justify-between items-center w-full px-3 py-2 text-sm font-medium text-gray-700  focus:outline-none"
                  >
                    <div
                      className={` cursor-pointer text-[14px] font-medium leading-9  text-shoorah-lightBlack dark:text-shoorah-darkBg`}
                      onClick={() => {
                        if (state?._id) {
                          handlePageChange('preview');
                        }
                      }}
                    >
                      Preview Challenge
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {showPage === 'details' && (
          <div className="mt-4">
            <AddDetails
              data={data}
              setData={setData}
              allData={allData}
              setAllData={setAllData}
              setNewChallenge={setNewChallenge}
              newChallenge={newChallenge}
            />
          </div>
        )}

        {showPage === 'tasks' && (
          <BadgeTaskForm
            handleFinalSubmit={handleFinalSubmit}
            challange={true}
            data={data}
            setData={setData}
            setNewChallenge={setNewChallenge}
            newChallenge={newChallenge}
          />
        )}
        {showPage === 'reward' && (
          <TaskRewardForm
            data={data}
            allData={allData}
            setNewChallenge={setNewChallenge}
            newChallenge={newChallenge}
          />
        )}
        {showPage === 'results' && (
          <WinnerResult
            data={data}
            setData={setData}
            setNewChallenge={setNewChallenge}
            newChallenge={newChallenge}
          />
        )}
        {showPage === 'summary' && (
          <Summary />
        )}
         
        {showPage === 'preview' && (
          <ChallengePreview
            handlePageChange={handlePageChange}
            setNewChallenge={setNewChallenge}
            newChallenge={newChallenge}
          />
        )}
      </div>
    </>
  );
}

export default NewChallenges;
